function handleOpenInSameWindow(url) {
    if (top) {
        top.window.location.href = url;
    }
    else {
        window.location.href = url;
    }
}
export default function handleResultClick(url, openInSameWindow, target) {
    if (target === void 0) { target = "_blank"; }
    if (openInSameWindow) {
        handleOpenInSameWindow(url);
    }
    else {
        var newWindow = window.open(url, target);
        if (!newWindow ||
            newWindow.closed ||
            typeof newWindow.closed == "undefined") {
            handleOpenInSameWindow(url);
        }
    }
}
